import { render, staticRenderFns } from "./instagramInsightsReport.vue?vue&type=template&id=47a11eba&"
import script from "./instagramInsightsReport.vue?vue&type=script&lang=js&"
export * from "./instagramInsightsReport.vue?vue&type=script&lang=js&"
import style0 from "./instagramInsightsReport.vue?vue&type=style&index=0&id=47a11eba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports